"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var document_search_helper_1 = require("../../util/document-search-helper");
var CategoryFilterComponent = /** @class */ (function () {
    function CategoryFilterComponent(kbService, classifierService, languageService, currentLanguageProvider) {
        this.kbService = kbService;
        this.classifierService = classifierService;
        this.languageService = languageService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.MetaFieldType = idm_kb_service_client_js_1.MetaFieldType;
        this.filter = new core_1.EventEmitter();
        this._values = new Map();
        this._isReady = false;
        this._destroy$ = new Subject_1.Subject();
    }
    CategoryFilterComponent.prototype.ngOnInit = function () {
        var _this = this;
        var currentLanguage$ = this.currentLanguageProvider.getCurrentLanguage();
        var metaFields$ = this.kbService.getMetaFields(this.category);
        var metaCategory$ = this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(this.category));
        Observable_1.Observable.zip(currentLanguage$, metaFields$, metaCategory$).pipe(operators_1.switchMap(function (data) {
            _this._currentLanguageId = data[0].getId();
            _this._metaFields = data[1].filter(function (metaField) { return _this.fields.indexOf(metaField.getSystemName()) !== -1; });
            _this._wfProcessId = data[2].getWFProcessId();
            var classifiers$ = [];
            _this._metaFields
                .forEach(function (value) {
                switch (value.getType()) {
                    case idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE: {
                        if (_this._wfProcessId) {
                            var filter = new idm_de_core_frontend_1.FilterBuilder().is('WFProcessID', _this._wfProcessId).buildJson();
                            classifiers$.push(_this.classifierService.loadClassifiersViewByFilter(value.getCompoundCategorySystemName(), filter)
                                .pipe(operators_1.map(function (classifierViews) {
                                return {
                                    category: value.getCompoundCategorySystemName(),
                                    values: classifierViews
                                };
                            })));
                        }
                        break;
                    }
                    case idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY: {
                        _this._filterEntitySearchFields = _this.constructEntitySearchFieldsMap(_this._metaFields);
                        break;
                    }
                    case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER:
                    case idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT: {
                        classifiers$.push(_this.classifierService.loadClassifiersView(value.getCompoundCategorySystemName())
                            .pipe(operators_1.map(function (classifierViews) {
                            return {
                                category: value.getCompoundCategorySystemName(),
                                values: classifierViews
                            };
                        })));
                        break;
                    }
                }
            });
            return classifiers$.length ? Observable_1.Observable.zip.apply(Observable_1.Observable, classifiers$) : Observable_1.Observable.of([]);
        }), operators_1.map(function (data) {
            _this._classifiers = document_search_helper_1.DocumentSearchHelper.constructClassifiersViewMap(data);
            _this._isReady = true;
        }), operators_1.takeUntil(this._destroy$)).subscribe();
    };
    CategoryFilterComponent.prototype.constructEntitySearchFieldsMap = function (metaFields) {
        var _this = this;
        var filterEntitySearchFields = new Map();
        metaFields
            .filter(function (value) { return value.getType() === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY; })
            .forEach(function (value) {
            _this.kbService.getNameMetaFieldIds(value.getCompoundCategorySystemName()).subscribe(function (nameMeasures) {
                var nameFields = nameMeasures.map(function (nameMeasure) { return nameMeasure.getSystemName(); });
                filterEntitySearchFields.set(value.getSystemName(), nameFields);
            });
        });
        return filterEntitySearchFields;
    };
    CategoryFilterComponent.prototype.onValuesChange = function (value, field) {
        this._values.set(field, value);
        this.filter.emit(document_search_helper_1.DocumentSearchHelper.constructFilterCriteria(this.metaFields, this.values));
    };
    CategoryFilterComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    Object.defineProperty(CategoryFilterComponent.prototype, "metaFields", {
        get: function () {
            return this._metaFields;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CategoryFilterComponent.prototype, "isReady", {
        get: function () {
            return this._isReady;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CategoryFilterComponent.prototype, "currentLanguageId", {
        get: function () {
            return this._currentLanguageId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CategoryFilterComponent.prototype, "values", {
        get: function () {
            return this._values;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CategoryFilterComponent.prototype, "classifiers", {
        get: function () {
            return this._classifiers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CategoryFilterComponent.prototype, "filterEntitySearchFields", {
        get: function () {
            return this._filterEntitySearchFields;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], CategoryFilterComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], CategoryFilterComponent.prototype, "fields", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], CategoryFilterComponent.prototype, "filter", void 0);
    CategoryFilterComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-category-filter',
            styles: [require('./category-filter.component.css')],
            template: require('./category-filter.component.html')
        }),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_message_language_service_client_js_1.LanguageService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], CategoryFilterComponent);
    return CategoryFilterComponent;
}());
exports.CategoryFilterComponent = CategoryFilterComponent;
//# sourceMappingURL=category-filter.component.js.map